import debounce from 'debounce'
import { useEffect, useMemo, useRef } from 'react'

// source: https://github.com/alibaba/hooks/blob/master/packages/hooks/src/useDebounceFn/index.ts
// eslint-disable-next-line @typescript-eslint/no-explicit-any
type AnyFunction = (...args: any[]) => any
export interface DebounceOptions { immediate: boolean }

export const useDebounceFnV2 = <F extends AnyFunction>(fn: F, wait?: number, options?: DebounceOptions) => {
  const fnRef = useRef(fn)
  fnRef.current = fn

  const debouncedFn = useMemo(
    () => {
      return debounce(
        (...args: Parameters<F>): ReturnType<F> => {
          return fnRef.current(...args)
        },
        wait,
        options,
      )
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [],
  )

  // Clear the debounced function when the component unmounts
  useEffect(() => {
    return () => {
      debouncedFn.clear()
    }
  }, [debouncedFn])

  return debouncedFn
}
